import { AppBar, Toolbar, withTheme } from 'material-ui';
import React, { Component } from 'react';

class SubHeader extends Component {
  render() {
    return (
      <AppBar position="fixed" style={{color: this.props.theme.typography.display1.color, background: 'white'}} className={this.props.className}>
        <Toolbar>
          {this.props.children}
        </Toolbar>
      </AppBar>
    );
  }
}

export default withTheme()(SubHeader);



// WEBPACK FOOTER //
// ./src/components/SubHeader.js